import { Button, Grid } from '@mui/joy';
import React, { useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertFromHTML, convertToRaw, Modifier } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import ShowDescription from './ShowDescriptions';
import CreateDescription from './CreateDescription';
import './aijobdes.css';

export default function AiJobDesc() {
  const [showPage, setShowPage] = useState(true);
  return (
    <>
      <Grid container spacing={3} style={{ height: 'auto', marginTop: '20px' }}>
        <Grid container item xs={12}>
          <Grid item xs={12} md={10}>
            <h5
              style={{
                color: '#ddd', // Soft white for contrast
                fontSize: '1.25rem', // Balanced size
                fontWeight: '600', // Slightly bold but not overwhelming
                textTransform: 'capitalize', // Classy instead of uppercase
                letterSpacing: '0.5px', // Minimal spacing for a refined look
                fontFamily: "'Poppins', sans-serif", // Clean modern font
                textAlign: 'center',
                borderBottom: '2px solid rgba(219, 209, 202, 0.5)', // Subtle bottom border for elegance
                paddingBottom: '5px'
              }}
            >
              AI-Assisted Job Description
            </h5>
          </Grid>
          <Grid item xs={12} md={2}>
            {showPage ? (
              <button
                className="cre-button"
                // sx={{ backgroundColor: '#3c3c3c', color: 'white', padding: '8px' }}
                onClick={() => {
                  setShowPage((prev) => !prev);
                }}
              >
                Create Description
              </button>
            ) : (
              <button
                className="cre-button"
                onClick={() => {
                  setShowPage((prev) => !prev);
                }}
              >
                Show Description
              </button>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          {showPage ? <ShowDescription /> : <CreateDescription setShowPage={setShowPage} />}
        </Grid>
      </Grid>
    </>
  );
}
